import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AllService } from '../rest/all.service';
import { SupplierService } from '../rest/Supplier.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../authentication/login/auth.service';
import { BackService } from '../rest-model/back.service';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
  providers: [AuthService, AllService, SupplierService, BackService]
})

export class CallbackComponent implements OnInit {

  public Preferences_Notification_List: any = [];

  loginToken :string = "";
  isNotify:boolean = false;
  Get_Preferences_Notification_List_By_Token = [];
  notificationsAccepted:boolean = false;

  isTokenTransfer:boolean =false;
  counterMandatoryMessage:number = 0;
  pendingMandatory = [];
  code: any;
  errorIn: any;
  signed = false;
  Id_Contract:number = 0;
  constructor(
    public authService: AuthService,
    private route:ActivatedRoute,
    private router :Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastsManager,
    private allService: AllService,
    private backEndServices: BackService,
    vcr: ViewContainerRef,
  ) {
    this.toastr.setRootViewContainerRef(vcr);


  }
//Check User funcion after login

  ngOnInit() {

    localStorage.setItem('key', '');
    localStorage.setItem('jwt', '');

    this.route.paramMap.subscribe(async p => {

        if(p.has("lt")){
          this.counterMandatoryMessage =0;

            this.loginToken = p.get("lt");

            if(this.loginToken.length < 36 ){
              this.redirectTo_Login('No es una sesión valida. Favor de intentar de nuevo, si el mensaje continua favor de contactar a su Administrador.')
              return;
            }

            localStorage.setItem('key', this.loginToken);
            await this.GetLoginToken();//JWT

        }

    });
  }
  ngAfterContentInit(): void {

  }

  async GetLoginToken(){

    var Message:string ='';
    var varRes = await this.backEndServices.GetTokenJWT({
      appToken: environment.AppToken,
      LoginToken:localStorage.getItem('key'),
      enviroment: environment.Ambiente,
    }).then(res=>{

        if (res.code === 1){

          localStorage.setItem('jwt',res.message)
          return true;

        }else {
          Message = res.message;
          return false;
        }

    });
    if (varRes){

      this.checkNotificationAccepted(); //First Request SSO
      await this.isExistCustomerModule(); //Permisos aplicacion
      this.Supplier_Validity_DocumentsService()
      this.tokenTransService(this.loginToken,false);
      this.redirectTo_Starter();


    }else {

      this.redirectTo_Login('Error inesperado al iniciar, favor de intentar de nuevo. Mensaje del sistema: ' + Message );

    }
  }

  checkNotificationAccepted(){
    this.backEndServices.post(
      {
        entidad:'User',
        funcion:24,
        enviroment: environment.Ambiente,
        data:{
          Id_Application: 5
        }
      }).subscribe(result => {
        if(result.code == 1 ){
            this.notificationsAccepted = result.data.Pending == 0;
        }
      }, error =>  console.log(error)
      );

  }

  async isExistCustomerModule(){


 await  this.backEndServices.post_async( {
    entidad: "Customer",
    funcion:116,
    data:{
      Module_Token:"13D05915-AD6E-4B3E-A2D6-5D00B6C5E2C0"
    }

  } ).then(res => {

        if(res.result){
            try{
              if(res.data.Status !== 'V'){

                var MesageToSend = "No se tiene acceso a esta aplicación."

              //  this.toastr.error('No se tiene acceso a esta aplicación.', 'Error', { toastLife: 10000, showCloseButton: true });

                this.redirectTo_Login(MesageToSend);

              }

            }catch{
              //En caso de error no tiene aceeso
             // this.toastr.error('No se tiene acceso a esta aplicación.', 'Error', { toastLife: 10000, showCloseButton: true });
              this.redirectTo_Login(MesageToSend);

            }
        }


  });
  }

  sessionExpired(res) {
    if (res.Result) {
      return true;
    } else {
      if (res.Codigo === 0) {
        this.toastr.info('Su sesión ha expirado, sera redireccionado.');
        this.redirectTo_Login();
      } else if (res.Codigo < 0) {
        this.toastr.error(res.Message, 'Error!', { toastLife: 10000, showCloseButton: true });
        return false;
      } else {
        return true;
      }
    }
  }

  //GS Funciona para validar la vigencia de documentos 04/06/2021
 Supplier_Validity_DocumentsService() {
    this.allService.Supplier_Validity_Documents(this.loginToken).subscribe(resp => {

      if (this.sessionExpired(resp)) {

        if (resp.Active === 'V' ) {
          if (resp.Remaing_Days < 0 ){

            swal({
              title: 'Vigencia de documentos',
              html: resp.Message,
              // width: '100%',
              type: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: 'Aceptar',
              cancelButtonText: 'Cancelar',
              focusCancel: false,
              focusConfirm: true,
            }).then((result) => {
              if (result.value) {
                this.isExistePendingMandatoryService();
                localStorage.setItem('isBLocked','V');


              }
            });

          } else {
            this.isExistePendingMandatoryService();
          }
        } else {
          this.isExistePendingMandatoryService();
        }
      }
    },
    (error)=>{
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      this.spinner.hide();
    });
  }


  isExistePendingMandatoryService() {
    this.allService.isExistePendingMandatory(this.loginToken).subscribe(resp => {
      if (this.sessionExpired(resp)) {
        if (resp.NotifMandatory) {
          this.pendingNotifMandatoryService();
        } else {
          this.tokenTransService(this.loginToken, false);// this.responseLogin.statusMFA

          this.redirectTo_Starter();

        }
      }
    },
    (error)=>{
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      this.spinner.hide();
    });
  }

pendingNotifMandatoryService() {

    this.allService.pendingNotifMandatory(this.loginToken).subscribe(resp => {

      if (this.sessionExpired(resp)) {
        this.pendingMandatory = resp;
        this.printAlertMandatory()


        //TODO
        //Check loca



      }
    },
    (error)=>{
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      this.spinner.hide();
    });
  }

  tokenTransService(token, stSMFA) {

    this.allService.tokenTrans(token).subscribe(res => {

      if (!res.Result) {
        this.toastr.error('Hay conflicto al iniciar sesión. Inicia sesión.', 'Error', { toastLife: 10000, showCloseButton: true });

      }
    },
    (error)=>{
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      this.spinner.hide();
    });
  }


 printAlertMandatory() {
  const sTitleSwal = 'Notificación importante';
    var ischeck = false;
    if (this.pendingMandatory[this.counterMandatoryMessage].Content.Length > 900) {
      if(this.pendingMandatory[this.counterMandatoryMessage].File_Path !== ''){
        swal({
          title: sTitleSwal,
          html: this.pendingMandatory[this.counterMandatoryMessage].Content + '<br></br><a href="'+this.pendingMandatory[this.counterMandatoryMessage].File_Path+'" target="_blank"><i class="fa fa-download" aria-hidden="true"></i> Descargar documento</a> ',
          type: 'warning',
          showCancelButton: true,
          width: '100%',
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          focusCancel: true,
          focusConfirm: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.acceptNotifMandatoryService(this.pendingMandatory[this.counterMandatoryMessage].Id_Mandatory);
            this.counterMandatoryMessage++;
            if ( this.isTokenTransfer == false){
              this.tokenTransService(this.loginToken,false);
              this.isTokenTransfer= true;
              ischeck = true;
            }

          }else {
            ischeck = false;
            this.redirectTo_Login();
          }
        });
      } else{
        swal({
          title: sTitleSwal,
          html: this.pendingMandatory[this.counterMandatoryMessage].Content,
          width: '100%',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          focusCancel: true,
          focusConfirm: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.acceptNotifMandatoryService(this.pendingMandatory[this.counterMandatoryMessage].Id_Mandatory);
            this.counterMandatoryMessage++;
            if ( this.isTokenTransfer == false){
              this.tokenTransService(this.loginToken,false);
              this.isTokenTransfer= true;
              ischeck = true;
            }

          }else {
            ischeck = false;
            this.redirectTo_Login();
          }
        });
      }
    } else {
      if(this.pendingMandatory[this.counterMandatoryMessage].File_Path !== ''){
        swal({
          title: sTitleSwal,
          html: this.pendingMandatory[this.counterMandatoryMessage].Content + '<br></br><a href="'+this.pendingMandatory[this.counterMandatoryMessage].File_Path+'" target="_blank"><i class="fa fa-download" aria-hidden="true"></i> Descargar documento</a> ',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          focusCancel: true,
          focusConfirm: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.acceptNotifMandatoryService(this.pendingMandatory[this.counterMandatoryMessage].Id_Mandatory);
            this.counterMandatoryMessage++;
            if ( this.isTokenTransfer == false){
              this.tokenTransService(this.loginToken,false);
              this.isTokenTransfer= true;
              ischeck = true;
            }


          }else {
            ischeck = false;
            this.redirectTo_Login();
          }
        });
      } else{
        swal({
          title: sTitleSwal,
          html: this.pendingMandatory[this.counterMandatoryMessage].Content,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          focusCancel: true,
          focusConfirm: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.acceptNotifMandatoryService(this.pendingMandatory[this.counterMandatoryMessage].Id_Mandatory);
            this.counterMandatoryMessage++;
            if ( this.isTokenTransfer == false){
              this.tokenTransService(this.loginToken,false);
              this.isTokenTransfer = true;
              ischeck = true;
            }


          }else {
            ischeck = false;
            this.redirectTo_Login();
          }
        });
      }
    }
    /*
    debugger;
    console.log( this.isTokenTransfer )
    if ( this.isTokenTransfer == true){

     this.redirectTo_Starter();
    }
*/

  }

  redirectTo_Starter(){

      const redirect = "/starter";
      this.router.navigate([redirect]);

  }

  redirectTo_Login(MessageSend?:string){

    var redirect:string = '';
    try {
      // In case the var messageSand has no content
      if(MessageSend.length > 0){
        redirect = "/authentication/login/"+MessageSend;
       // this.router.navigate([redirect])
      }
    }catch(error){
       redirect = "/";
    }
    //destroy session

      this.backEndServices.post(
      {
        entidad:'User',
        funcion:33,
        data:{test:'redireclogin'}
      }).subscribe(

        () => {

        localStorage.setItem('key', '');
        localStorage.setItem('jwt', '');
        this.router.navigate([redirect]);
      }, () => {


          localStorage.setItem('key', '');
          localStorage.setItem('jwt', '');
          this.router.navigate([redirect]);

      });

}

  acceptNotifMandatoryService(id) {
    this.allService.acceptNotifMandatory(id,this.loginToken).subscribe(resp => {
      if (this.sessionExpired(resp)) {
      }
    },
    (error)=>{
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      this.spinner.hide();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/callback/callback.component.ts